import { BudgetProps } from '../../../features/budget/interfaces';
import api from '../../../services/api/api';

export const getBudgetById = async (id: string) => {
  const { data } = await api.get<BudgetProps>(`/budget/${id}`);

  return data;
};
